import { render, staticRenderFns } from "./document-home.vue?vue&type=template&id=3a8084f0&"
import script from "./document-home.vue?vue&type=script&lang=js&"
export * from "./document-home.vue?vue&type=script&lang=js&"
import style0 from "./document-home.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports